import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import DeviceList from './components/DeviceList';
import DeviceRegistration from './components/DeviceRegistration';
import DeviceAssignment from './components/DeviceAssignment';
import DeviceSearch from './components/DeviceSearch';
import Statistics from './components/Statistics';
import EmployeeManagement from './components/EmployeeManagement';
import Settings from './components/Settings';
import DeviceManagers from './components/DeviceManagers';
import TransferRequests from './components/TransferRequests';
import DeviceRequests from './components/DeviceRequests';
import EmailScheduler from './components/EmailScheduler';
import Login from './components/Login';
import './App.css';

const AppLayout = () => {
  const [currentView, setCurrentView] = useState('dashboard');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { user, logout } = useAuth();

  const renderCurrentView = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard onViewChange={setCurrentView} />;
      case 'devices':
        return <DeviceList />;
      case 'register':
        return <DeviceRegistration />;
      case 'employees':
        return <EmployeeManagement />;
      case 'assign':
        return <DeviceAssignment />;
      case 'search':
        return <DeviceSearch />;
      case 'transfer-requests':
        return <TransferRequests />;
      case 'device-requests':
        return <DeviceRequests />;
      case 'stats':
        return <Statistics />;
      case 'email-scheduler':
        return <EmailScheduler />;
      case 'settings':
        return <Settings />;
      case 'device-managers':
        return <DeviceManagers />;
      default:
        return <Dashboard onViewChange={setCurrentView} />;
    }
  };

  return (
    <TenantProvider user={user}>
      <div className="app-container">
        <Sidebar
          currentView={currentView}
          onViewChange={setCurrentView}
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          user={user}
          onLogout={logout}
        />
        <div className={`main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="content-area">
            {renderCurrentView()}
          </div>
        </div>
      </div>
    </TenantProvider>
  );
};

const AppContent = () => {
  const { user, loading, isAuthenticated, handleLoginSuccess } = useAuth();

  const handleLoggedIn = (loggedInUser) => {
    handleLoginSuccess(loggedInUser);
  };

  if (loading) {
    return (
      <div className="app-container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: 'var(--light-text-secondary)' }}>Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLoggedIn={handleLoggedIn} />;
  }

  return <AppLayout />;
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
